import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import refundService from "../services/refundService";
import inventoryService from "../services/inventoryService";
const initialState = {
    inventories: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
};

const inventorySlice = createModule({
    name: 'inventory',
    initialState,
    reducers: {
        addInventory: (state) => {
            state.loading = true;
        },
        findAll: (state) => {
            state.loading = true;
        },
        updateInventory: (state) => {
            state.loading = true;
        },
        closeInventory: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.inventories = payload.body.content;
            state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.findAll]({ payload }) {
            try {
                const { data } = yield call(inventoryService.findAll);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },
        *[A.addInventory]({ payload }) {
            try {
                const { data } = yield call(inventoryService.addInventory, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                yield call(payload.onError);
            }
        },

        *[A.updateInventory]({ payload }) {
            try {
                const { data } = yield call(inventoryService.updateInventory, payload);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data.body);

            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.closeInventory]({ payload }) {
            try {
                const { data } = yield call(inventoryService.closeInventory, payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        
    }),
});

export default inventorySlice;
export const inventoryActions = inventorySlice.actions;